<script>

    const squareColors = ['blue', 'green', 'purple'];

</script>

<main>
    <div class="My-App">
    <!--I want 3 squares-->
    {#each squareColors as color, index}
        <div class="square" style="background-color: {color}">
        {index}
        </div>
    {/each}
     </div>
</main>

<style>
main{
    display: flex;
    justify-content: center;
}
    .My-App{
        padding: 100px;
    }

    .square{
        height: 200px;
        width: 200px;
        color: aquamarine;
        padding: 10%;
        background-color: black;
    }
</style>